import PinList from "@/components/PinList";
import { AD_POSITION } from "@/constants/ads";
import { RENDERCARDTYPE } from "@/constants/renderCardType";
import { getAds, getRecommendPins } from "@/services";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import useRequest from "@/utils/useReq";
import { useSetState } from "ahooks";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
// 为你推荐
function PinRecommendPinList({
  pinId,
  isModal,
  fileId,
  similiarList,
  showSimilarList,
  customColumn,
}) {
  const [query, setQuery] = useSetState({
    page: 1,
    pinId: null,
  });
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [ads, setAds] = useState([]);
  const [scrollableTarget, setScrollableTarget] = useState(null);
  const [masonryKey, setMasonryKey] = useState(null);

  // 解决瀑布流容器大小判断，因为弹窗过程需要时间，延迟计算
  useEffect(() => {
    const timeout = setTimeout(() => {
      setMasonryKey(pinId);
    }, 400);

    return () => {
      clearTimeout(timeout);
    };
  }, [pinId]);

  useRequest(
    async () => {
      const { page, pinId } = query;

      if (!pinId) {
        return;
      }

      const [result, waterfallAd] = await Promise.all([
        getRecommendPins({
          pin_id: pinId,
          per_page: 20,
          page,
        }),
        page > 1 && page % 2 === 1 // 第一页不展示广告，每40个插一
          ? getAds({
              positions: [AD_POSITION.PINDETAIL_WATERFALL_PER_PAGE],
              variables: {
                user_tag: ["pin"],
              },
            })
          : null,
      ]);

      const pins = result?.pins || [];

      if (waterfallAd?.[0] && pins.length > 0) {
        //追加到列表前
        pins.unshift({
          ...waterfallAd[0],
          pin_id: `recommend-${waterfallAd[0].material.id}-${page}`,
          type: "recommend",
        });
      }

      if (pins.length <= 0) {
        setHasMore(false);
      }

      setDataSource(dataSource.concat(pins));
    },
    {
      refreshDeps: [query],
    }
  );

  useRequest(async () => {
    const result = await getAds({
      positions: [53, 57],
      file_id: fileId,
    });

    setAds(
      result?.reduce((result, item) => {
        if (item) {
          result.push({
            ...item,
            pin_id: `recommend-${item.material.id}`,
            type: "recommend",
          });
        } else {
          result.push(null);
        }
        return result;
      }, []) || []
    );
  });

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      setQuery({
        page: query.page + 1,
      });

      pvTracker(getPageData());
    }
  }, [dataSource, query, setQuery]);

  useEffect(() => {
    if (pinId) {
      setHasMore(true);
      setDataSource([]);
      setQuery({
        page: 1,
        pinId,
      });
    }
  }, [pinId, setQuery]);

  useEffect(() => {
    if (isModal) {
      setScrollableTarget(document.querySelector(".pinDetailModal"));
    }
  }, [isModal]);

  const list = useMemo(() => {
    if (dataSource.length <= 0 || ads.length <= 0) {
      return dataSource;
    }
    const list = [...dataSource];
    if (showSimilarList && similiarList.data?.pins?.length) {
      list.unshift({ ...similiarList, type: RENDERCARDTYPE.similar, pinId });
    }
    return [
      ...list.slice(0, 3),
      ...ads.slice(1, 2).filter((i) => i),
      ...list.slice(3),
    ];
  }, [dataSource, ads, similiarList, pinId, showSimilarList]);

  if (isModal && !scrollableTarget) {
    return null;
  }

  return (
    <PinList
      disableModal={!isModal}
      disableQueue={true}
      disableFile={true}
      dataSource={list}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      scrollableTarget={scrollableTarget}
      masonryKey={masonryKey}
      customColumnNum={customColumn}
      isModal={isModal}
    />
  );
}
export default memo(PinRecommendPinList);
